import { CURRENT_PROMOTION, formatDiscount } from './config'

export function DiscountBanner() {
  const promotion = CURRENT_PROMOTION
  if (!promotion) {
    return null
  }

  return (
    <div className="pointer-events-auto flex items-center justify-center gap-x-6 bg-green-300 px-6 py-2.5 text-center text-base text-green-800">
      {promotion.bannerMessage}
    </div>
  )
}
